"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const appStateSelectAppId_1 = __importDefault(require("../../shared/appStateSelectAppId"));
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const buildCallableLogout = (args) => async ({ functionId, callbacks, executeProcesses, processor, store, }) => {
    try {
        const { currentUser } = processor.root.firebase.auth();
        if (currentUser) {
            processor.root.firebase.auth().signOut();
            processor.root.setUserInfo(undefined);
            const appId = (0, appStateSelectAppId_1.default)(store.getState());
            if (args === null || args === void 0 ? void 0 : args.onLoggedOut) {
                await args.onLoggedOut(appId);
            }
        }
        executeProcesses(undefined, callbacks.successProcess);
    }
    catch (error) {
        if (!(0, valueIsRecord_1.default)(error)) {
            executeProcesses(functionId, callbacks.errorProcess, 'Unknown error');
        }
        else {
            executeProcesses(functionId, callbacks.errorProcess, error);
        }
    }
};
exports.default = buildCallableLogout;
